(ns ycweb.components.buttons
  (:require
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.util.core :as u]))

(defn href-on-click [on-click-fn]
  {:href "#"
   :on-click
   (fn [e]
     #?(:cljs
        (.preventDefault e))
     (on-click-fn))})

(rum/defc button < rum/reactive
  [text click
   {:keys [icon-left icon-right icon-only icon-class
           secondary call-to-action text-link disabled text-default
           raised full square-corners bordered
           large small on-dark muted opaque persistent success negative text-negative
           toggle-block text-size text-hidden class]
    :as options}]

  [:a
   (merge
     (href-on-click
       #(when
          (and click (not (cmn/curval disabled)))
          (click)))

     {:class
      (u/bem :button
        [;; Icon
         (when icon-left :has-icon-left)
         (when icon-right :has-icon-right)
         (when icon-only :has-icon-only)

         (when (nil? click) :ish)
         (when muted :muted)
         (when opaque :opaque)
         (when persistent :persistent)
         (when success :success)
         (when negative :negative)

       ;; Size
         (cond large :large
           small :small
           :else :standard)
         (when full :full)

       ;; Button type
         (cond
           (cmn/curval disabled) :disabled
           secondary :secondary
           call-to-action :cta
           text-link :text-link
           text-default :text-default
           toggle-block nil
           :else :primary)

       ;; Shape
         (when square-corners :persistent)

         (when bordered :bordered)

       ;; Perceived Height
         (if raised :raised :flat)]
        (when class class)
        (when text-size (keyword (str "u-text-" text-size)))
        (when toggle-block :toggle-block-button)
        (when on-dark :u-text-white))
      :href (when (not (cmn/curval disabled)) "#")})
   [:span.button__text
    (when text-negative {:class :u-text-status-negative})
    (when icon-left
      [:i.button__icon
       {:class (u/bem :icon [icon-class icon-left :block (when-not (or muted secondary) :is-light)])}])
    (when icon-right
      [:i.button__icon
       {:class (u/bem :icon [icon-class icon-right :block (when-not (or muted secondary) :is-light)])}])
    (when icon-only
      [:i.button__icon
       {:class (u/bem :icon [icon-class icon-only :block (when-not (or muted secondary) :is-light)])}])
    (if text-hidden
      [:span.u-hidden-from-view (cmn/curval text)]
      (cmn/curval text))]])

(rum/defc button-icon < rum/reactive
  [{:keys [icon-class icon-display icon-size icon-color icon-jsclass  icon
           icon-input icon-id icon-custom-attrs icon-hidden-text]
    :as options}]
  (let [class
        {:class
         (u/bem :icon
           [(when icon icon)

            (if (= icon-color :light) :is-light :is-dark)

            (cond
              (= icon-size :tiny) :small
              (= icon-size :small) :medium
              (or (not icon-size) (= icon-size :medium)) nil
              (= icon-size :medium-large) :medium-large
              (= icon-size :large) :large)

            (if (= icon-display :inline) :inline :block)]
           (when icon-jsclass icon-jsclass)
           (when icon-class icon-class)
           (when icon-input :yc-text-input-icon))}

        attrs
        (u/maybe assoc
          (or icon-custom-attrs {})
          :id icon-id)]
    [:i
     (merge class attrs)
     (when icon-hidden-text [:span.u-hidden-from-view icon-hidden-text])]))

(rum/defc button-web < rum/reactive
  "text = WDI.
   //OPTIONS
   {
   :size - (:tiny :small :medium :large :huge)
   :id - WDI
   :class WDI
   :full Bool
   :jsclass WDI
   :combo Bool
   :style WDI OR keyword (:dark :light)
   :disabled Bool
   :type = WDI OR keyword (:submit :search :button :button-submit :reset :text :span-button)
   :role WDI
   :name WDI
   :href WDI
   :target WDI
   :icon (:arrow-right)
   :icon-placement (:left :right)
   :custom-attrs WDI {:target_class 'popup'}
   :hidden-text WDI (This creates a 'hidden-from-view' span inside the button (cannot be used on inputs).)
   }
   "
  [text
   {:keys [size full class disabled style combo jsclass href type flat-style floating
           target on-click scrollto name role id custom-attrs icon icon-only
           icon-placement hidden-text persistent square-corners loading? loading-text]
    :as   options}]
  (let [icon (if loading? :loading icon)
        icon-placement (if loading? :left icon-placement)
        text (if (and loading? loading-text) loading-text text)
        class
        {:class
         (u/bem :button
           [(or flat-style :raised)
            (if size size :default)
            (when persistent :persistent)
            (when floating :floating)
            (when full :full)
            (when persistent :persistent)
            (when square-corners :persistent)
            (cond
              (and (#{:light :secondary} style) (not disabled))
              [:secondary :bordered]

              (and (= style :secondary-noborder) (not disabled))
              :secondary

              (and (#{:dark :primary} style) (not disabled))
              :primary

              (and (= style :cta) (not disabled))
              :cta

              (and style (not disabled))
              style

              :else
              :primary)

            (when
              (and icon (not= icon :none) (not= icon :default) (not loading?))
              (cond
                icon-only
                :has-icon-only

                (or (= icon-placement :left) (not icon-placement))
                :has-icon-left

                (= icon-placement :right)
                :has-icon-right))

            (when (and disabled (or href (= type :span-button))) :disabled)]
           (when class class)
           (when combo :input-combo__button)
           (when jsclass jsclass))}

        attrs
        (u/maybe assoc
          (or custom-attrs {})
          :href (when (and (not disabled) href) href)

          :target target

          :on-click (when-not disabled on-click)

          :type
          (cond
            (and type (not= type :submit) (not= type :span-button))
            type

            (= type :submit)
            :submit)

          :disabled (when (and disabled (not= type :span-button) (not href)) true)

          :name name
          :role role
          :id id)

        icon-options
        (u/maybe assoc
          {}

          :icon icon

          :icon-color
          (when
            (and icon (not= icon :none) (not= icon :default))
            (if (#{:light :secondary :secondary-noborder} style) :dark :light))

          :icon-size
          (when
            (and icon (not= icon :none) (not= icon :default) (not icon-only))
            (cond
              (#{:tiny :small} size) :tiny
              (or (not size) (= size :medium)) :small
              (#{:large :huge} size) :medium))

          :icon-jsclass
          (when loading? :u-animate-spin))]
    (cond
      (and (= type :submit) (not icon) (not href))
      [:input (merge class attrs {:type "submit" :value (when text text)})]

      href
      [:a
       (merge class attrs)
       [:span.button__text
        (cond
          (and icon icon-only)
          (button-icon icon-options)

          (and icon (not (#{:default :none} icon)) (or (not icon-placement) (= icon-placement :left)))
          (button-icon (merge icon-options {:icon-display :inline :icon-class :button__icon})))
        text
        (when (and icon (= icon-placement :right) (not (#{:default :none} icon)))
          (button-icon (merge icon-options {:icon-display :block :icon-class :button__icon})))
        (when hidden-text [:span.u-hidden-from-view hidden-text])]]

      (= type :span-button)
      [:span
       (merge class attrs)
       (cond
         (and icon icon-only)
         (button-icon icon-options)

         (and icon (not (#{:default :none} icon)) (or (not icon-placement) (= icon-placement :left)))
         (button-icon (merge icon-options {:icon-display :inline :icon-class :svg-icon--text-left})))
       text
       (when (and icon (= icon-placement :right) (not (#{:default :none} icon)))
         (button-icon (merge icon-options {:icon-display :inline})))
       (when hidden-text [:span.u-hidden-from-view hidden-text])]

      :else
      [:button
       (merge class attrs)
       [:span.button__text
        (cond
          (and icon icon-only)
          (button-icon icon-options)

          (and icon (not (#{:default :none} icon)) (or (not icon-placement) (= icon-placement :left)))
          (button-icon (merge icon-options {:icon-display :inline :icon-class (when-not loading? :button__icon)})))
        text
        (when (and icon (= icon-placement :right) (not (#{:default :none} icon)))
          (button-icon (merge icon-options {:icon-display :block :icon-class :button__icon})))
        (when hidden-text [:span.u-hidden-from-view hidden-text])]])))

(rum/defcs button-clipboard < rum/reactive (rum/local false ::state)
  [s text
   {:keys
    [size full class disabled style combo jsclass href type flat-style
     target on-click scrollto name role id custom-attrs icon icon-only
     icon-placement hidden-text persistent square-corners]
    :as options} value-fn]
  (let [copied (rum/react (::state s))]
    (button-web
      (if copied "Copied" text)
      (merge
        options
        {:icon (if copied :success :copy-content)
         :icon-placement :right
         :on-click
         #?(:cljs
            (fn [e]
              (.stopPropagation e)
              (reset! (::state s) true)
              (u/copy-to-clipboard (value-fn))
              (.setTimeout js/window
                (fn [_] (reset! (::state s) false))
                2000))
            :clj
            nil)}))))

(rum/defc button-demo []
  [:div.layout-component-demo
   (cmn/section "Basic Buttons:"
     (cmn/row-full
       "A flat, primary button, of standard size:"
       (button "Button" #() {}))
     (cmn/row-full
       "A flat, primary button, of standard size, with icon to the left:"
       (button "Button" #() {:icon-class :2-2 :icon-left :arrow-left}))
     (cmn/row-full
       "A flat, primary button, of standard size, with icon to the right:"
       (button "Button" #() {:icon-class :2-2 :icon-right :arrow-right}))
     (cmn/row-full
       "A flat, secondary button, of standard size:"
       (button "Button" #() {:secondary true}))
     (cmn/row-full
       "A flat, \"Call To Action\" button, of standard size:"
       (button "Button" #() {:call-to-action true}))
     (cmn/row-full
       "A raised (shadow), primary button, of standard size:"
       (button "Button" #() {:raised true}))
     (cmn/row-full
       "A raised (shadow), primary button, of standard size, with icon to the left:"
       (button "Button" #() {:icon-class :2-2 :raised true :icon-left :arrow-left}))
     (cmn/row-full
       "A raised (shadow), primary button, of standard size, with icon to the right:"
       (button "Button" #() {:icon-class :2-2 :raised true :icon-right :arrow-right}))
     (cmn/row-full
       "A raised (shadow), secondary button, of standard size:"
       (button "Button" #() {:raised true :secondary true}))
     (cmn/row-full
       "A raised (shadow), \"Call To Action\" button, of standard size:"
       (button "Button" #() {:raised true :call-to-action true}))
     (cmn/row-full
       "A button that's styled to look like a text link (for \"tappability\"):"
       (button "Next" #() {:text-link true})))
   (cmn/section "Full Width Buttons:"
     (cmn/row-full
       "A raised, full-width, primary button, of standard size:"
       (button "Button" #() {:full true :raised true}))
     (cmn/row-full
       "A raised, full-width, \"Call To Action\" button, of large size, with icon to the right:"
       (button "Button" #() {:large true :full true :raised true :icon-right :arrow-right
                             :icon-class :2-2 :call-to-action true}))
     (cmn/row-full
       "An a-link / href button that is disabled with a CSS class:"
       (button "Next" #() {:large true :full true :raised true :disabled true})))])



